import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Organization from './Organization';
import DynamicOrganization from './DynamicOrganization';
import FunctionalStructure from './FunctionalStructure';
import PositionStructure from "./PositionStructure";

const OrgView = () => {
    const [activeTab, setActiveTab] = useState('organization');
    const tabLocation = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(tabLocation.search);
        const tab = params.get('tab');
        if (tab) setActiveTab(tab);
    }, [tabLocation.search]);

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
            <div className="bg-white dark:bg-gray-800 px-6 py-3 border-b border-gray-200 dark:border-gray-700">
                <h1 className="text-lg font-medium text-gray-800 dark:text-white">Organization View</h1>
            </div>

            <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                <div className="px-6">
                    <div className="flex space-x-8">
                        <button
                            onClick={() => setActiveTab('organization')}
                            className={`tour-organization-structure-tab py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'organization'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                            }`}
                        >
                            ORGANIZATION STRUCTURE
                        </button>
                        <button
                            onClick={() => setActiveTab('functional')}
                            className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'functional'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                            } tour-functional-structure-tab`}
                        >
                            FUNCTIONAL STRUCTURE
                        </button>
                        {/*<button*/}
                        {/*    onClick={() => setActiveTab('position')}*/}
                        {/*    className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${*/}
                        {/*        activeTab === 'position'*/}
                        {/*            ? 'border-blue-500 text-blue-600'*/}
                        {/*            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'*/}
                        {/*    }`}*/}
                        {/*>*/}
                        {/*    POSITION STRUCTURE*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>

            {activeTab === 'organization' && <Organization />}
            {activeTab === 'functional' && <FunctionalStructure />}
            {activeTab === 'position' && <PositionStructure/>}
        </div>
    );
};

export default OrgView;
